import { cn } from "@omni/utils/styles";

import { FlyoutButtonProps } from "./flyoutButton.props";

const FlyoutButton = ({
    active = false,
    title,
    size = "small",
    update
}: FlyoutButtonProps) => {
    const isSmall = size === "small";

    return (
        <div className={cn("tw:flex tw:h-full")}>
            <div className={cn("tw:relative tw:self-center")}>
                <div
                    tabIndex={0}
                    className={cn(
                        "tw:hover:cursor-pointer",
                        "tw:bg-danger tw:text-white tw:h-10 tw:w-37.5 tw:flex tw:justify-center",
                        "tw:items-center tw:text-center",
                        {
                            "tw:h-10": !isSmall
                        }
                    )}
                    onClick={() => update?.()}
                >
                    <span className={cn("tw:whitespace-nowrap")}>
                        {title}
                        <i
                            className={cn(
                                "tw:m-0 tw:ml-1.5 tw:transition-transform tw-duration-100",
                                `las la-angle-${active ? "up" : "down"}`
                            )}
                        />
                    </span>
                </div>
            </div>
        </div>
    );
};

export { FlyoutButton };
